import React from 'react';
import useTitle from '../../hooks/useTitle';

const Profile = () => {
    useTitle("My Profile")
    return (
        <div>
            
        </div>
    );
};

export default Profile;